import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-jewels-template-info',
  imports: [TranslatePipe],
  templateUrl: './jewels-template-info.component.html',
  styleUrls: [
    './jewels-template-info.component.scss',
    '../template-shared.stylesheet.scss',
  ],
})
export class JewelsTemplateInfoComponent {
  translationPrefix = input('', { transform: appendPrefix });
}
function appendPrefix(value: string | undefined): string {
  return value + 'jewels.';
}
